// The shared topic pool every mode draws from.
//
// A mode does not own its questions — it owns a STYLE OF PLAY. The topics are
// shared so that the same mode feels new every time, which is the whole reason
// the brief asks for a pool rather than a per-mode list.

export const TOPICS = [
  { id: 'football', label: 'Football & sport', emoji: '⚽' },
  { id: 'animals', label: 'Animals', emoji: '🐘' },
  { id: 'geography', label: 'Geography & flags', emoji: '🌍' },
  { id: 'space', label: 'Space', emoji: '🚀' },
  { id: 'history', label: 'History', emoji: '🏰' },
  { id: 'body', label: 'The human body', emoji: '🦠' },
  { id: 'gaming', label: 'Gaming', emoji: '🎮' },
  { id: 'music', label: 'Music', emoji: '🎸' },
  { id: 'food', label: 'Food', emoji: '🍕' },
  { id: 'records', label: 'Records & extremes', emoji: '🏆' },
  { id: 'science', label: 'Weird science', emoji: '🧪' },
];

export const ALL_TOPIC_IDS = TOPICS.map((t) => t.id);

export const topicById = (id) => TOPICS.find((t) => t.id === id) ?? null;
export const topicLabel = (id) => topicById(id)?.label ?? id;
export const topicEmoji = (id) => topicById(id)?.emoji ?? '❓';
